<template>
  <div>
    <el-dialog
      class="modal"
      title="刪除輪詢"
      :visible.sync="delModal"
      width="375px"
    >
      <div>確認刪除 {{ currentData.customer_id }} ?</div>
      <el-input v-model="oneCode" placeholder="驗證碼"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="delModal = false" class="btn">取消</div>
        <div @click="confirmDel" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯例外規則"
      :visible.sync="checkApmModal"
      width="375px"
    >
      <p style="color:red">
        商戶單號傳送關鍵字，或下單傳送例外參數(pay_verify=1)，都將會依配置指定通道。
      </p>
      <el-form
        :inline="false"
        :model="addCheckData"
        class="demo-form-inline"
        style="width:100%"
      >
        <el-form-item label="指定通道代碼" style="width:100%">
          <el-input
            style="width:100%"
            v-model="currentData.check_contains_apm"
            type="text"
            placeholder="通道代碼"
          ></el-input>
        </el-form-item>
        <el-form-item label="商戶單號關鍵字(逗號(,)做分隔)" style="width:100%">
          <el-input
            style="width:100%"
            v-model="check_contains"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="checkApmModal = false" class="btn">取消</div>
        <div @click="confirmCheckApm" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="限制銀行清單"
      :visible.sync="allowBankModal"
      width="375px"
    >
      <el-form
        :inline="false"
        :model="addCheckData"
        class="demo-form-inline"
        style="width:100%"
      >
        <el-form-item label="例如: GCASH (逗號(,)做分隔)" style="width:100%">
          <el-input
            style="width:100%"
            v-model="allow_bank_name"
            type="textarea"
            placeholder="台灣銀行"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="allowBankModal = false" class="btn">取消</div>
        <div @click="confirmAllowBank" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯密鑰"
      :visible.sync="editKeyModal"
      width="375px"
    >
      <el-form :inline="true" :model="addCheckData" class="demo-form-inline">
        <el-form-item label="密鑰">
          <el-input v-model="payment_check_key" placeholder="密鑰"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editKeyModal = false" class="btn">取消</div>
        <div @click="confirmEditKey" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="新增查核設定"
      :visible.sync="addCheckModal"
      width="375px"
    >
      <el-form :inline="true" :model="addCheckData" class="demo-form-inline">
        <el-form-item label="編號">
          <el-input v-model="addCheckData.no" placeholder="編號"></el-input>
        </el-form-item>
        <el-form-item label="網址">
          <el-input v-model="addCheckData.url" placeholder="網址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addCheckModal = false" class="btn">取消</div>
        <div @click="confirmAddCheck" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯查核設定"
      :visible.sync="editCheckModal"
      width="375px"
    >
      <el-form :inline="true" :model="editCheckData" class="demo-form-inline">
        <el-form-item label="編號">
          <el-input v-model="editCheckData.no" placeholder="編號"></el-input>
        </el-form-item>
        <el-form-item label="網址">
          <el-input v-model="editCheckData.url" placeholder="網址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editCheckModal = false" class="btn">取消</div>
        <div @click="confirmEditCheck" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="反查模式選擇"
      :visible.sync="closeSetModal"
      width="375px"
    >
      <el-select filterable v-model="currentMode" style="width:100%">
        <!-- @change="urlPush" -->
        <el-option label="關閉" :value="0"></el-option>
        <el-option
          v-for="(mode, key) in modeList"
          :label="mode.name"
          :value="key"
          :key="key"
        ></el-option>
      </el-select>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="closeSetModal = false" class="btn">取消</div>
        <div @click="confirmCloseSet" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="查核設定"
      :visible.sync="checkSetModal"
      width="800px"
    >
      <div style="display:flex;justify-content:space-between">
        <div v-if="$permission('paymentMethod.customer_p_m.update')">
          狀態:
          <el-button size="mini" type="primary" @click="closeSet">{{
            currentData.payment_check_mode == 0 ? "關閉" : "開啟"
          }}</el-button>
        </div>
        <div>
          <el-button size="mini" type="primary" @click="editkey"
            >編輯密鑰</el-button
          >
          <el-button size="mini" type="primary" @click="addCheck"
            >新增查核設定</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="setTable"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          header-align="center"
          align="center"
          prop="no"
          label="編號"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="url"
          label="網址"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button size="mini" @click="editCheck(scope.row)"
                >編輯</el-button
              >
              <el-button size="mini" @click="delCheck(scope.row)"
                >刪除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="checkSetModal = false" class="btn">取消</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯通道接口"
      :visible.sync="editModal"
      width="800px"
    >
      <p class="text-danger" style="width: 100%;margin-top:18px">
        金額限額: 設置0, 表示不限制
      </p>
      <p class="text-danger" style="width: 100%;margin-top:18px">
        餘額限制: 商戶餘額在餘額限制內,通道才可使用．未限制,表示不限制
      </p>
      <el-table
        stripe
        :data="currentData"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column header-align="center" align="center" label="選擇">
          <template slot-scope="scope">
            <div>
              <el-checkbox v-model="scope.row.check"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="通道代碼"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="alias"
          label="通道名稱"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="金額下限">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.lower"
                placeholder="金額下限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="金額上限">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.upper"
                placeholder="金額上限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="權重(1-9)">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.weight"
                placeholder="權重(1-9)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editModal = false" class="btn">取消</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="新增通道接口"
      :visible.sync="addModal"
      width="800px"
    >
      <label>請輸入商戶號</label>
      <el-select
        filterable
        v-model="addData.customer_id"
        style="width:100%"
        placeholder="商戶號"
      >
        <!-- @change="urlPush" -->
        <el-option
          :label="customer.customer_id"
          :value="customer.customer_id"
          v-for="customer in customerList"
          :key="customer.customer_id"
        ></el-option>
      </el-select>
      <p class="text-danger" style="width: 100%;margin-top:18px">
        限額0表示不限制
      </p>
      <el-table
        stripe
        :data="addTable"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column header-align="center" align="center" label="選擇">
          <template slot-scope="scope">
            <div>
              <el-checkbox v-model="scope.row.check"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="通道代碼"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="alias"
          label="通道名稱"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="金額下限">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.lower"
                placeholder="金額下限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="金額上限">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.upper"
                placeholder="金額上限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="權重(1-9)">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.weight"
                placeholder="權重(1-9)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">取消</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-input v-model="searchData.id" placeholder="商戶號"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      size="mini"
      @click="add"
      v-if="$permission('paymentMethod.customer_p_m.store')"
      >新增</el-button
    >
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="customer_id"
        label="商戶號"
      >
      </el-table-column>
      <el-table-column header-align="center" align="center" label="用戶名稱">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            {{ scope.row.user.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <el-button
              size="mini"
              v-if="$permission('admin')"
              @click="allowBank(scope.row)"
              >限制銀行清單</el-button
            >
            <el-button size="mini" @click="checkSet(scope.row)"
              >查核設定</el-button
            >
            <el-button
              size="mini"
              v-if="$permission('admin')"
              @click="checkApm(scope.row)"
              >例外規則</el-button
            >
            <el-button size="mini" @click="editData(scope.row)">查看</el-button>
            <el-button size="mini" @click="delData(scope.row)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [],
      page: 1,
      currentData: {},
      inSearch: false,
      saveData: false,
      searchData: {},
      pagination: {},
      addModal: false,
      addData: {},
      editModal: false,
      customerList: [],
      addTable: [],
      checkSetModal: false,
      setTable: [],
      modeList: false,
      closeSetModal: false,
      currentMode: "",
      editCheckModal: false,
      editCheckData: {},
      addCheckModal: false,
      addCheckData: {},
      payment_check_key: "",
      editKeyModal: false,
      delModal: false,
      oneCode: "",
      allowBankModal: false,
      allow_bank_name: "",
      checkApmModal: false,
      check_contains: ""
    };
  },
  watch: {
    "addData.customer_id"() {
      this.$http
        .get(
          `/back/payment_method/customer_models/methods/${this.addData.customer_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            let data = res.data.data;
            data.forEach(e => {
              e.lower = 0;
              e.upper = 0;
              e.weight = 1;
              e.check = false;
            });
            this.addTable = data;
          }
        });
    },
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    confirmCheckApm() {
      let check_contains = [];

      let arr = this.check_contains.split(",");
      if (arr.length) {
        arr.forEach(e => {
          if (e) {
            check_contains.push(e);
          }
        });
      }
      this.$http
        .put(`/back/payment_method/customer_models/${this.currentData.id}`, {
          check_contains,
          check_contains_apm: this.currentData.check_contains_apm
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
            this.checkApmModal = false;
          }
        });
    },
    checkApm(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.checkApmModal = true;
      try {
        this.check_contains = this.currentData.check_contains.join();
      } catch {
        this.check_contains = "";
      }
    },
    confirmAllowBank() {
      let allow_bank_name = [];
      let arr = this.allow_bank_name.split(",");
      if (arr.length) {
        arr.forEach(e => {
          if (e) {
            allow_bank_name.push(e);
          }
        });
      }
      this.$http
        .put(`/back/payment_method/customer_models/${this.currentData.id}`, {
          allow_bank_name
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
            this.allowBankModal = false;
          }
        });
    },
    allowBank(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      try {
        this.allow_bank_name = this.currentData.allow_bank_name.join();
      } catch {
        this.allow_bank_name = "";
      }
      this.allowBankModal = true;
    },
    confirmDel() {
      this.$http
        .delete(
          `/back/payment_method/customer_models/${this.currentData.id}?oneCode=${this.oneCode}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.delModal = false;
            this.$message.success("成功");
          }
        });
    },
    delData(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.oneCode = "";
      this.delModal = true;
    },
    confirmEdit() {
      let channels = [];
      this.currentData.forEach(e => {
        if (e.check) {
          channels.push(e);
        }
      });
      this.$http
        .put(`/back/payment_method/customer_models/${this.currentData.putId}`, {
          channels
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.editModal = false;
            this.getData();
          }
        });
    },
    editData(data) {
      this.$http
        .get(`/back/payment_method/customer_models/methods/${data.customer_id}`)
        .then(res => {
          if (res.data.code == 0) {
            data.channels.forEach(e => {
              res.data.data.forEach(data => {
                if (e.id == data.id) {
                  data.check = true;
                  data.lower = e.lower;
                  data.upper = e.upper;
                  data.weight = e.weight;
                }
              });
            });
            this.currentData = res.data.data;
            this.currentData.putId = data.id;
            this.editModal = true;
          }
        });
    },
    confirmEditKey() {
      this.$http
        .put(`/back/payment_method/customer_models/${this.currentData.id}`, {
          payment_check_key: this.payment_check_key
        })
        .then(res => {
          if (res.data.code == 0) {
            this.editKeyModal = false;
            this.currentData.payment_check_key = this.payment_check_key;
            this.$message.success("成功");
          }
        });
    },
    editkey() {
      this.payment_check_key = JSON.parse(
        JSON.stringify(this.currentData)
      ).payment_check_key;
      this.editKeyModal = true;
    },
    confirmAddCheck() {
      this.$http
        .post(
          `/back/payment_method/${this.currentData.customer_id}/validation`,
          this.addCheckData
        )
        .then(res => {
          if (res.data.code == 0) {
            this.checkSet(this.currentData);
            this.$message.success("成功");
            this.addCheckModal = false;
          }
        });
    },
    addCheck() {
      this.addCheckData = {};
      this.addCheckModal = true;
    },
    delCheck(data) {
      this.$alert(`確定刪除編號${data.no}?`, "刪除查核設定", {
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        beforeClose: (method, instance, done) => {
          if (method == "confirm") {
            this.$http
              .delete(
                `/back/payment_method/${this.currentData.id}/validation/${data.id}`
              )
              .then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.checkSet(this.currentData);
                  done();
                } else {
                  done();
                }
              });
          } else {
            done();
          }
        }
      });
    },
    confirmEditCheck() {
      this.$http
        .put(
          `/back/payment_method/${this.currentData.customer_id}/validation/${this.editCheckData.id}`,
          this.editCheckData
        )
        .then(res => {
          if (res.data.code == 0) {
            this.editCheckModal = false;
            this.checkSet(this.currentData);
            this.$message.success("成功");
          }
        });
    },
    editCheck(data) {
      this.editCheckData = JSON.parse(JSON.stringify(data));
      this.editCheckModal = true;
    },
    confirmCloseSet() {
      this.$http
        .put(`/back/payment_method/customer_models/${this.currentData.id}`, {
          payment_check_mode: this.currentMode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.closeSetModal = false;
            this.currentData.payment_check_mode = this.currentMode;
          }
        });
    },
    closeSet() {
      this.currentMode = JSON.parse(
        JSON.stringify(this.currentData)
      ).payment_check_mode;
      this.closeSetModal = true;
    },
    checkSet(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      if (!this.modeList) {
        this.$http.get(`/back/payment/check/mode`).then(res => {
          if (res.data.code == 0) {
            this.modeList = res.data.data;
          }
        });
      }
      this.$http
        .get(`/back/payment_method/${data.customer_id}/validation`)
        .then(res => {
          if (res.data.code == 0) {
            this.currentDate = JSON.parse(JSON.stringify(data));
            this.checkSetModal = true;
            this.setTable = res.data.data;
          }
        });
    },
    confirmAdd() {
      let data = {
        channels: [],
        customer_id: this.addData.customer_id
      };
      this.addTable.forEach(e => {
        if (e.check) data.channels.push(e);
      });
      this.$http
        .post(`/back/payment_method/customer_models`, data)
        .then(res => {
          if (res.data.code == 0) {
            this.addModal = false;
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    add() {
      this.$http.get(`/back/payment_method/customers?no_page=1`).then(res => {
        if (res.data.code == 0) {
          this.addTable = [];
          this.addData = {};
          this.customerList = res.data.data;
          this.addModal = true;
        }
      });
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/payment_method/customer_models`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
